export default IconTextColor => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-text-color" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M9 15v-7a3 3 0 0 1 6 0v7" />
  <path d="M9 11h6" />
  <path d="M5 19h14" />
</svg>`;